import apiClient from '../client';
import {
  BASE_ENDPOINTS,
  SERVICES,
  VERSIONS,
  RESOURCES
} from '../common/constants';

const CATEGORY_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.CATEGORY,
  false // No tenant ID in the base URL
);

export const categoryApi = {
  getCategoryList: () => apiClient.get(`${CATEGORY_BASE}/list`),
  getCategory: id => apiClient.get(`${CATEGORY_BASE}/${id}`),
  createCategory: combinedData =>
    apiClient.post(`${CATEGORY_BASE}`, combinedData),
  updateCategory: (id, combinedData) =>
    apiClient.put(`${CATEGORY_BASE}/${id}`, combinedData),
  deleteCategory: id => apiClient.delete(`${CATEGORY_BASE}/${id}`)
};
export default categoryApi;
